import { createStyles, IconButton, makeStyles, TablePagination, Theme } from "@material-ui/core";
import { TablePaginationActionsProps } from "@material-ui/core/TablePagination/TablePaginationActions";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import React from "react";
import { LabelDisplayedRows } from "./LabelDisplayedRows";

export interface TableFooterProps {
  page?: number;
  rowsPerPage?: number;
  count?: number;
  handleChangePage?(event: unknown, newPage: number): void;
  handleChangeRowsPerPage?(event: React.ChangeEvent<HTMLInputElement>): void;
  rowsPerPageOptions: number[];
  footerWidth?: string;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    countTotal: {
      marginLeft: "auto",
      marginBottom: "auto",
      [theme.breakpoints.down("xs")]: {
        background: "#e2f4fb",
        position: "sticky",
        width: "inherit",
        marginLeft: "0px",
      },
      "& .MuiTablePagination-caption": {
        display: "none",
      },
      "& .MuiTablePagination-input": {
        color: COLORS.primary,
      },
      "& .MuiSelect-icon": {
        color: COLORS.primary,
      },
      "& .MuiSelect-select.MuiSelect-select": {
        border: "solid 0.5px",
        borderRadius: "4px",
      },
    },
    spanStyled: {
      color: COLORS.primary,
      backgroundColor: "rgba(64, 180, 229, 0.15)",
      borderRadius: "4px",
      padding: "7px",
      width: "14rem",
    },
  })
);
export const TableFooter = ({
  rowsPerPage,
  page = 1,
  count = 0,
  handleChangePage = () => {},
  handleChangeRowsPerPage = () => {},
  footerWidth = "auto",
  rowsPerPageOptions,
}: TableFooterProps) => {
  const styles = useStyles();

  return (
    <div className={styles.countTotal}>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage=""
        ActionsComponent={TablePaginationActions}
      />
    </div>
  );
};
function TablePaginationActions(props: TablePaginationActionsProps) {
  const { count, page, rowsPerPage, onPageChange } = props;
  const { text } = useText();
  const styles = useStyles();
  function handleBackButtonClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    onPageChange(event, page - 1);
  }
  function handleNextButtonClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    onPageChange(event, page + 1);
  }
  return (
    <>
      <span className={styles.spanStyled}>{text.all.per_page}</span>
      <IconButton
        // eslint-disable-next-line react/jsx-no-bind
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="Previous Page"
      >
        <KeyboardArrowLeft style={{ color: "#399ebf" }} />
      </IconButton>
      <LabelDisplayedRows count={count} page={page} total={rowsPerPage} />
      <IconButton
        // eslint-disable-next-line react/jsx-no-bind
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Next Page"
      >
        <KeyboardArrowRight style={{ color: "#399ebf" }} />
      </IconButton>
    </>
  );
}
